import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
    static requiredTrim(control: AbstractControl): ValidationErrors | null {
        return (control.value ?? '').trim().length === 0 ? { required: true } : null;
    }
}
